import React, { useState } from 'react';

import { saveCommunitiesEmailNotificationRecipients } from 'apis/CommunityAPI';
import { useRootContext } from 'components/layout/RootContext';
import SettingsPage from 'components/Settings/SettingsPage';
import { CommunityPreferenceNotification, CommunityPreferenceType } from 'types/communities';

import CommunitySettingLabel from '../../CommunitySettingLabel';
import {
  COMMUNITY_LABEL_COLOR,
  COMMUNITY_SETTINGS_PAGE_TYPE,
  COMPETITOR_INCENTIVE_UPDATES,
  EMAIL_NOTIFICATION_TYPE,
} from '../../constants';
import EmailNotificationsRecipientsModal from '../EmailNotificationsRecipientsModal';

const getItemStatusComponent = (item: CommunityPreferenceType) => {
  const { statusElements } = COMPETITOR_INCENTIVE_UPDATES;

  switch (item.preferences?.incentive_email_notifications) {
    case true:
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
          <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.POSITIVE}>
            {statusElements.ON.label}
          </CommunitySettingLabel>
          <span style={{ color: 'var(--gray-dark)', fontSize: 12 }}>
            {item.receiving_notification_users_no}/{item.total_users_no} users receiving
          </span>
        </div>
      );
    case false:
    default:
      return (
        <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.NEUTRAL}>{statusElements.OFF.label}</CommunitySettingLabel>
      );
  }
};

const CompetitorIncentive = () => {
  const { showMessage } = useRootContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [communitiesToModify, setCommunitiesToModify] = useState<CommunityPreferenceType[]>([]);
  const [refetchCommunities, setRefetchCommunities] = useState<() => void | undefined>();
  const [clearSelection, setClearSelection] = useState<() => void | undefined>();

  const showCommunitiesEditModal = (items: any[]) => {
    setCommunitiesToModify(items);
    setIsModalOpen(true);
  };

  const savePreferenceRecipients = (newStatus: number, preferenceNotifications: CommunityPreferenceNotification[]) => {
    setLoading(true);

    const payload = {
      communities: preferenceNotifications,
      email_notifications_enabled: newStatus,
    };

    saveCommunitiesEmailNotificationRecipients(EMAIL_NOTIFICATION_TYPE.COMPETITOR_INCENTIVE_UPDATES, payload)
      .then(() => {
        showMessage('success', 'All selected communities updated successfully');
        if (refetchCommunities) refetchCommunities();
        if (clearSelection) clearSelection();
      })
      .catch(() => {
        showMessage('error', 'Failed to update one or more communities!');
      })
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
      });
  };

  return (
    <>
      <SettingsPage
        filterOptions={Object.values(COMPETITOR_INCENTIVE_UPDATES.statusElements)}
        getItemStatusComponent={getItemStatusComponent}
        showCommunitiesEditModal={showCommunitiesEditModal}
        settingsPageType={COMMUNITY_SETTINGS_PAGE_TYPE.COMPETITOR_INCENTIVE}
        setRefetchCommunities={setRefetchCommunities}
        setClearSelection={setClearSelection}
        filterField={COMPETITOR_INCENTIVE_UPDATES.field}
        notificationType={EMAIL_NOTIFICATION_TYPE.COMPETITOR_INCENTIVE_UPDATES}
      />
      <EmailNotificationsRecipientsModal
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        loading={loading}
        title={COMPETITOR_INCENTIVE_UPDATES.title}
        communitiesToModify={communitiesToModify}
        onSave={savePreferenceRecipients}
        settingsPageType={COMMUNITY_SETTINGS_PAGE_TYPE.COMPETITOR_INCENTIVE}
      />
    </>
  );
};

export default CompetitorIncentive;
